export const mockDataCampaign = {
  color: "rgb(59, 4, 107)",
  imgSrc: { large: "https://images.hallow.app/covers/81_xl.webp" },
  illustrationImgSrc: "https://images.hallow.app/covers/81_xl.webp",
} as const;
